import React from 'react';
import statuses from 'data/task-question-status.json';
import { Button } from "primereact/button";
import {useUpdatePriorityTaskQuestionsMutation} from "../../../apis/priorityApi";
import {useUpdateKpiTaskQuestionsMutation} from "../../../apis/kpiApi";
import {useUpdateSAMTaskQuestionsMutation} from "../../../apis/samApi";
import { useParentTaskOwner } from "hooks/taskHooks";
import {useUserProfileQuery} from "../../../apis/authenticationApi";

/**
 *
 * @param {*} param0
 * @returns
 */
const MessageCenterTableRowAction = ({isOutbox, row}) => {
    const [updatePriorityTaskQuestions] = useUpdatePriorityTaskQuestionsMutation();
    const [updateKpiTargetQuestions] = useUpdateKpiTaskQuestionsMutation();
    const [updateSAMTaskQuestions] = useUpdateSAMTaskQuestionsMutation();
    const finalStatuses = statuses.filter(e => e.complete);
    const ownerParentTask = useParentTaskOwner(row.task, true);
    const {data: userProfile} = useUserProfileQuery();
    
    const status = statuses.find(e => e.code === row.status);

    const onActioned = (action) => {
        const questions = (row.task?.needHelpQuestionList || []).map(q => 
            q.id === row.id? {text: q.text, status: action, deadline: q.deadline, createdAt: q.createdAt}: q
        );
        
        if(row.task.taskType === 'Priority') {
            updatePriorityTaskQuestions({id: row.task.id, needHelpQuestionList: questions});
        }
        else if(row.task.taskType === 'KPI') {
           updateKpiTargetQuestions({id: row.task.id, needHelpQuestionList: questions});
        }
        else if(row.task.taskType === 'SAM') {
           updateSAMTaskQuestions({id: row.task.id, needHelpQuestionList: questions});
        }
     };
    
    const inboxActions = (!ownerParentTask || ownerParentTask.id === userProfile?.company?.account) && status?.nextAction? <Button label={status?.nextAction?.label ?? ''} onClick={() => onActioned(status.nextAction.code)}/> : <></>;
    const outboxActions = status?.nextAction? 
            <>
            {finalStatuses.map((item,i) =>  <Button key={i} label={`${item?.completeActionText}`} icon={item?.severity === 'success' ? "pi pi-thumbs-up" : "pi pi-thumbs-down"} onClick={() => onActioned(item.code)} />)}
            </> : <></>;
    return isOutbox? outboxActions: inboxActions;
}

export default MessageCenterTableRowAction;
